import './OnboardingErrorView.scss';
import { useSalesforceSync } from '@hooks';
import { Button, Row, Space } from 'antd';
import { EMAILS, ONBOARDING_ERROR_COPY, URLS } from '@sonar-software/sonar-ts-constants';
import { GatewayCard, GatewayContent } from '../../general';
import React, { useCallback } from 'react';
export const OnboardingErrorView = ({ onRestart }) => {
    const { resetSync } = useSalesforceSync();
    const handleRestart = useCallback(() => {
        resetSync();
        onRestart();
    }, [onRestart, resetSync]);
    return (React.createElement(GatewayContent, null,
        React.createElement(GatewayCard, { className: 'onboarding-error-view', title: ONBOARDING_ERROR_COPY.SOMETHING_WENT_WRONG },
            React.createElement("p", null,
                ONBOARDING_ERROR_COPY.PARTIAL_HAVING_ISSUES,
                React.createElement("a", { href: URLS.SUPPORT_EMAIL, rel: 'noopener', target: '_blank' }, EMAILS.SUPPORT),
                ONBOARDING_ERROR_COPY.PARTIAL_QUESTIONS),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Row, { justify: 'center' },
                React.createElement(Space, { size: 24 },
                    React.createElement(Button, { id: 'restart-onboarding-button', onClick: handleRestart, size: 'large', type: 'primary' }, ONBOARDING_ERROR_COPY.RESTART_ONBOARIDNG))))));
};
